import React from "react";
import * as S from "./closebutton";
import { ReactComponent as CloseButtonIcon } from "assets/images/close-button.svg";

export const CloseButton = (props) => {
  return (
    <S.StyledCloseButton onClick={props.onClick} state={props.state}>
      <CloseButtonIcon />
    </S.StyledCloseButton>
  );
};
